module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_5.e344a9cc.png";